import product from '@/api/inventory/product'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  categories: [],
  unit_measures: [],
  inventory_types: [],
  assembly_products: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_CATEGORIES(state, categories) {
    state.categories = categories
  },
  SET_UNIT_MEASURES(state, unitmeasures) {
    state.unit_measures = unitmeasures
  },
  SET_INVENTORY_TYPES(state, inventory_type) {
    state.inventory_types = inventory_type
  },
  SET_ASSEMBLY_PRODUCTS(state, product) {
    state.assembly_products = product
  }
}

export const actions = {
  async fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )
    let product_resource = await product.get({ params })
    context.commit('RECEIVE_RESOURCES', product_resource)
    return Promise.resolve(product_resource)
  },

  store(context, data) {
    return product.store(data)
  },

  update(context, data) {
    return product.update(data)
  },

  async find(context, id) {
    return await product.find(id)
  },

  destroy(context, id) {
    return product.destroy(id)
  },

  uploadPhoto(context, data) {
    return product.storePhoto(data)
  },

  getPhoto(context, id) {
    return product.getPhoto(id)
  },

  async getAssemblyProduct({ commit }) {
    let assembly_product = await product.assemblyProduct()
    commit('SET_ASSEMBLY_PRODUCTS', assembly_product)
  },

  async dataBeforeCreate({ commit, state }) {
    if (!state.categories.length > 0) {
      let response = await product.category()
      commit('SET_CATEGORIES', response)
    }
    if (!state.unit_measures.length > 0) {
      let response = await product.unitmeasure()
      commit('SET_UNIT_MEASURES', response)
    }
    if (!state.inventory_types.length > 0) {
      let response = await product.inventorytype()
      commit('SET_INVENTORY_TYPES', response)
    }
    if (!state.assembly_products.length > 0) {
      let assembly_product = await product.assemblyProduct()
      commit('SET_ASSEMBLY_PRODUCTS', assembly_product)
    }
  }
}
